import { Button, Card, Input, Radio, RadioGroup } from '@nextui-org/react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { httpClient } from '../axios';
import CustomRadio from './CustomRadio';
import { v4 as uuid } from "uuid";
import { useNavigate, useParams, useLocation } from "react-router";
import back from "../assets/images/back1.jpg";
import logo from "../assets/images/logo.png";
import MainNavbar from "./MainNavbar"; // ✅ Added import for navbar

const PAYPALBACKEND_URL = "https://payment.membershipgalaxy.com";

const plansList = [
  {
    id: 1,
    name: "Annual Membership",
    value: 250,
    discountedValue: 100,
  },
];

const Checkout = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [planSelect, setPlanSelect] = useState(plansList[0]);
  const [paymentMethod, setPaymentMethod] = useState("full");
  const [partailPayment, setPartialPayment] = useState(0);
  const [selectedFundingSource, setSelectedFundingSource] = useState();
  const [isCheck, setIsCheck] = useState(true);
  const [isChequeNo, setIsChequeNo] = useState("");
  const [isChequeValid, setIsChequeValid] = useState(false);

  useEffect(() => {
    setPaymentMethod("full");
    localStorage.setItem("pay", "full");
    localStorage.setItem("plan", JSON.stringify(plansList[0]));
  }, []);

  const initialOptions = {
    "client-id": "AU9qMUHJnX0GbemLBe1DOJJCln7DF9e1Toinj1vK1TeSk2gn2xdOvhFALMrgoTvzkaaYeA8NAY8buwsD",
    currency: "USD",
    intent: "capture",
    components: "marks,buttons",
  };

  async function createOrder() {
    try {
      const response = await fetch(`${PAYPALBACKEND_URL}/api/orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cart: [
            {
              name: JSON.parse(localStorage.getItem("plan")).name,
              value:
                localStorage.getItem("pay") === "partial"
                  ? JSON.parse(localStorage.getItem("plan")).discountedValue / 2
                  : JSON.parse(localStorage.getItem("plan")).discountedValue,
            },
          ],
        }),
      });

      const orderData = await response.json();
      if (orderData.id) return orderData.id;
      const errorDetail = orderData?.details?.[0];
      const errorMessage = errorDetail
        ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
        : JSON.stringify(orderData);
      throw new Error(errorMessage);
    } catch (error) {
      console.error(error);
      console.log(`Could not initiate PayPal Checkout...<br><br>${error}`);
    }
  }

  async function onApproveFunc(data, actions) {
    try {
      const response = await fetch(`${PAYPALBACKEND_URL}/api/orders/${data.orderID}/capture`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const orderData = await response.json();
      const errorDetail = orderData?.details?.[0];
      if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
        return actions.restart();
      } else {
        const transaction =
          orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
          orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];

        savePayment(transaction, orderData?.payer);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const changePaymentMethod = (e) => {
    localStorage.setItem("pay", e);
    setPaymentMethod(e);
    if (e === "partial") {
      setPartialPayment(planSelect.discountedValue / 2);
    } else {
      setPartialPayment(0);
    }
  };

  const onPlanChange = (e) => {
    localStorage.setItem("plan", JSON.stringify(e));
    setPlanSelect(e);
    setPartialPayment(0);
    setPaymentMethod("full");
  };

  const savePayment = async (pay, user) => {
    if (isCheck) {
      if (!isChequeNo || isChequeNo.trim() === "") {
        toast.warn("Please enter a valid Cheque Number before submitting.");
        setIsChequeValid(true);
        return;
      }
    }

    const payment = {
      emailid: location.state?.email,
      trandate: pay?.create_time || new Date().toISOString(),
      transactionid: isCheck ? uuid() : pay?.id,
      planname: planSelect.name,
      planvalue: planSelect.discountedValue,
      status: isCheck ? "COMPLETED" : pay?.status,
      paymenttype: paymentMethod,
      mode: isCheck ? "cheque" : "online",
      chequeno: isChequeNo,
    };

    httpClient.post("/transaction", payment).then((res) => {
      try {
        navigate("/success");
        localStorage.setItem("transaction", JSON.stringify(res.data.result));
        toast.success(res.data.message);
      } catch (err) {
        toast.error("Something went wrong");
      }
    });
  };

  return (
    <div
      className="h-svh flex flex-col items-center"
      style={{ backgroundImage: `url(${back})`, backgroundSize: "cover" }}
    >
      {/* ✅ Replaced manual header with MainNavbar */}
      <MainNavbar />

      <Card className="p-8 w-full md:w-[55vw] overflow-y-scroll h-[85vh] md:h-auto md:overflow-auto mt-4">
        <PayPalScriptProvider options={initialOptions}>
          {/* ==== Plans List ==== */}
          <RadioGroup
            value={planSelect}
            onValueChange={onPlanChange}
            className="w-full"
            label="Plan"
          >
            {plansList?.map((item) => (
              <CustomRadio
                key={item.id}
                value={item}
                description={
                  <div>
                    <span className="line-through text-gray-400 mr-2">
                      ${item.value}
                    </span>
                    <span className="text-green-600 font-bold animate-blink">
                      ${item.discountedValue}
                    </span>
                  </div>
                }
              >
                *Introductory offer
                <br />
                <span className="text-[1rem] font-normal text-gray-800">
                  {item.name}{" "}
                </span>
                <span className="text-[0.95rem] font-normal text-gray-600">
                  (For Family incl kids and parents)
                </span>
              </CustomRadio>
            ))}
          </RadioGroup>

          {/* ==== Payment Method ==== */}
          <RadioGroup
            value={paymentMethod}
            onValueChange={changePaymentMethod}
            label="Select Payment Method"
            color="primary"
            className="my-4"
          >
            <Radio value="full">Full Payment</Radio>
          </RadioGroup>
          <div>
            <span>IACF Admin will confirm payment receipt.</span>
          </div>

          {/* ==== Pay with PayPal ==== */}
          <div className="flex flex-col gap-4 my-4">
            <div className="flex flex-col items-center gap-2 mt-4">
              <button
                onClick={() =>
                  window.open(
                    "https://www.paypal.com/donate/?hosted_button_id=Q3V28V42KZBTN",
                    "_blank"
                  )
                }
                className="w-full py-3 px-6 rounded-full flex justify-center items-center gap-2 text-[#003087] font-semibold text-lg transition-transform transform hover:scale-[1.02]"
                style={{
                  backgroundColor: "#FFC439", // PayPal yellow
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                >
                  <path
                    fill="#003087"
                    d="M6.5 21.5l1.7-10.6c.1-.4.4-.7.8-.7h5.3c2.1 0 3.7.4 4.7 1.2.9.7 1.3 1.8 1.1 3.3-.2 1.5-.8 2.7-1.7 3.4-1 .7-2.5 1.1-4.6 1.1H9.9l-.6 3.9H6.5z"
                  />
                  <path
                    fill="#009CDE"
                    d="M16.4 5.2c.6-.9 1.5-1.4 2.6-1.5.4 0 .8 0 1.2.1-.4 2.4-1.1 4.6-2.2 6.6-.6.9-1.5 1.5-2.6 1.5h-5.1l.5-3.3h4c.8 0 1.4-.3 1.6-.9z"
                  />
                </svg>
                Pay with PayPal
              </button>
            </div>

            {/* 🔸 Cheque Form */}
            <div className="flex items-center gap-4 mt-6">
              <Input
                value={isChequeNo}
                onChange={(e) => {
                  setIsChequeNo(e.target.value);
                  setIsChequeValid(false);
                }}
                type="text"
                isRequired
                isInvalid={isChequeValid && (!isChequeNo || isChequeNo.trim() === "")}
                errorMessage="Cheque number is required"
                label="Cheque Number"
              />
              <Button onClick={() => savePayment(null, null)} color="primary">
                Submit
              </Button>
            </div>
          </div>
        </PayPalScriptProvider>
      </Card>
    </div>
  );
};

export default Checkout;
